<template>
    <div class="topbar text-center p-3">
        <img src="@/assets/img/logochanel.png" class="img-logo"/>
    </div>
</template>
<script>
export default {
    name: 'top-bar',// <top-bar>
}
</script>
<style lang="scss" scoped>

    .topbar {
                
    }
    .img-logo {
        width: 40px;
    }
</style>
